import { render, staticRenderFns } from "./battle-array.vue?vue&type=template&id=f413fc3a&scoped=true&"
import script from "./battle-array.vue?vue&type=script&lang=js&"
export * from "./battle-array.vue?vue&type=script&lang=js&"
import style0 from "./battle-array.vue?vue&type=style&index=0&id=f413fc3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f413fc3a",
  null
  
)

export default component.exports